/** Aligned with noor-app. Public marketing site: noorhc.app */
export const BRAND = {
  appName: 'Noor',
  tagline: 'Health Companion',
  brandName: 'Zanders Group',
  brandDescription:
    'A multinational development organisation focusing on therapy and humanity-driven initiatives through software solutions.',
  bundleId: 'zand.noor.app',
  scheme: 'noor',
  domains: {
    marketing: 'noorhc.app',
    app: 'noorhc.app',
    cms: 'cms.noorhc.app',
    roadmap: 'roadmap.noorhc.app',
    support: 'noorhc.app',
    auth: 'noorhc.app',
  },
  email: {
    support: 'support@noorhc.app',
  },
  /** Set when App Store listing is live */
  appStoreUrl: null,
  /** When true, store badges open store URLs. When false, they open the notify signup popup. */
  storeDownloadsLive: false,
  tier1AnnualProductId: 'zand.noor.app.tier1.annual',
  storageBucketContent: 'content',
  logos: {
    color: '/noor-logo.png',
    white: '/noor-logo-white.png',
  },
}

export function publicAsset(path) {
  const base = process.env.PUBLIC_URL || ''
  return `${base}${path}`
}

export function brandUrl(host, path = '') {
  const normalized = path.startsWith('/') ? path : path ? `/${path}` : ''
  return `https://${BRAND.domains[host]}${normalized}`
}

export function supportMailto(subject) {
  const base = `mailto:${BRAND.email.support}`
  if (!subject) return base
  return `${base}?subject=${encodeURIComponent(subject)}`
}

export function playStoreUrl() {
  return `https://play.google.com/store/apps/details?id=${BRAND.bundleId}`
}

export function isStoreDownloadsLive() {
  return Boolean(BRAND.storeDownloadsLive)
}
